import styled from "@emotion/styled";
import theme from "@theme";
import { css, Global } from "@emotion/react";
import InnoIcons from "InnoUI/innoicons";

const globalStyles = css`
  .ant-otp {
    width: 100%;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  margin: -8px -8px -8px -8px;
  font-family: Roboto;
`;

const Login = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  font-size: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.white};
`;

const LoginForm = styled.div`
  background-color: ${theme.colors.white};
  padding: 10px;
  border-radius: 25px;
  width: 60%;
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    width: 60%;
  }

  @media (min-width: 1025px) {
    width: 50%;
  }
`;

const Form = styled.form`
  width: 100%;
`;

const TransparentInput = styled.input`
  width: 93%;
  padding: 2px 2px 2px 20px;
  margin-bottom: 10px;
  background-color: transparent;
  color: ${theme.colors.black};
  font-size: 16px;
  font-family: Roboto;
  outline: none;
  border: 1px solid grey;
  border-radius: 5px;
  height: 30px;
  &::placeholder {
    opacity: 0.5;
    color: ${theme.colors.black};
    font-size: 12px;
    font-family: Roboto;
  }
`;

const Button = styled.button`
  width: 100%;
  border: none;
  background: ${theme.gradient.themeGradient};
  color: ${theme.colors.white};
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 5px;
  margin-top: 5px;
  height: 35px;
  text-align: center;
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
`;

const backButton = styled.button`
  color: #000000;
  width: 100%;
  border: none;
  font-size: 12px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 35px;
  text-align: center;
  background: white;
`;
const ToggleButton = styled.button`
  position: absolute;
  top: 57%;
  right: 100px;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 12px;
  cursor: pointer;
  color: ${theme.colors.black};
  opacity: 0.5;
  @media (min-width: 768px) {
    top: 57%;
    right: -20px;
  }

  @media (min-width: 1024px) {
    top: 57%;
    right: 0px;
  }
  @media (max-width: 1440px) {
    top: 57%;
    right: -10px;
  }
`;
const PasswordInputContainer = styled.div`
  position: relative;
`;

const Label = styled.label`
  color: ${theme.colors.black};
  width: Hug (69px) px;
  height: Hug (19px) px;
  gap: 10px;
  opacity: 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 400;
  line-height: 19px;
`;

const VisibilityIcon = styled(InnoIcons.VisibilityIcon)`
  margin-right: 20px;
  width: 15px;
`;
const VisibilityOffIcon = styled(InnoIcons.VisibilityOffIcon)`
  margin-right: 20px;
  width: 15px;
`;

const SC = {
  Globalstyles: <Global styles={globalStyles} />,
  Container,
  Login,
  LoginForm,
  Form,
  TransparentInput,
  Button,
  ErrorMessage,
  backButton,
  ToggleButton,
  PasswordInputContainer,
  Label,
  VisibilityIcon,
  VisibilityOffIcon,
};

export default SC;
